import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitlab = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#FC6D26",
					d: "M21.95 13.522l-1.118-3.439-2.214-6.82a.383.383 0 0 0-.726 0l-2.214 6.816H8.32L6.107 3.262a.382.382 0 0 0-.726 0l-2.21 6.817-1.12 3.443a.762.762 0 0 0 .276.852L12 21.402l9.671-7.028a.763.763 0 0 0 .28-.852"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#E24329",
					d: "M12 21.397l3.678-11.318H8.324z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#FC6D26",
					d: "M12 21.397L8.32 10.079H3.174z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#FCA326",
					d: "M3.169 10.082l-1.12 3.44a.762.762 0 0 0 .276.85L12 21.403l-8.831-11.32z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#E24329",
					d: "M3.17 10.082h5.155L6.107 3.266a.383.383 0 0 0-.727 0l-2.21 6.816z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#FC6D26",
					d: "M12 21.397l3.678-11.318h5.156z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#FCA326",
					d: "M20.83 10.082l1.12 3.44a.76.76 0 0 1-.276.85L12 21.398l8.828-11.315h.003z"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-style-override": "false",
					fill: "#E24329",
					d: "M20.833 10.082H15.68l2.214-6.816a.382.382 0 0 1 .726 0l2.214 6.816z"
				})
			]
		})]
	})
});
export default SvgGitlab;
